/**
 *  @file       WorkerErrorBoundary.jsx
 *  @author     Alex Huctwith <alex@kingsds.network>
 *  @date       Mar 2024
 *
 *  This Error boundary catches errors in the worker and presents an error instead of crashing
 */
import { Component } from 'react';
import { debugging } from '@/lib/debugging';

export class WorkerErrorBoundary extends Component
{
  constructor(props)
  {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error)
  {
    if (error.message === 'No account to deposit credits into') // ignore other errors
    {
      // Update state so the next render will show the fallback UI.
      return { hasError: true };
    }
  }

  componentDidCatch(error, info)
  {
    debugging('worker') && console.debug('User deleted last keystore: ' + error, info);
  }

  render()
  {
    if (this.state.hasError)
    {
      // will render whatever is passed as a fallback
      return this.props.fallback;
    }

    return this.props.children;
  }
}
